import React from "react";
import { Freshchat } from "reactjs-freshchat";
import { Viewer } from "components/auth/types";
import Settings from "settings";
// @ts-ignore

type Props = {
  viewer: Viewer;
}

export default class FreshChatWidget extends React.Component<Props> {
  state = {
    hasError: false,
  };

  componentDidCatch () {
    this.setState({ hasError: true });
  }

  render () {
    const { viewer } = this.props;

    if (Settings.env === "development" || this.state.hasError) {
      return null;
    }

    return (
      <Freshchat
        token={Settings.freshchat_client_token}
        externalId={viewer.id}
        firstName={viewer.firstName || ""}
        lastName={viewer.lastName || ""}
      />
    );
  }
}
